export const WORKOUT_TYPES = [
    { value: "swimming", label: "Natação", icon: "mdi-swim", color: "#2196F3" },
    { value: "strength", label: "Musculação", icon: "mdi-dumbbell", color: "#FF5722" },
    { value: "running", label: "Corrida", icon: "mdi-run-fast", color: "#4CAF50" },
    { value: "wod", label: "WOD", icon: "mdi-lightning-bolt", color: "#FF9800" },
];

export const getWorkoutTypeConfig = (type) =>
    WORKOUT_TYPES.find(t => t.value === type) || WORKOUT_TYPES[0];

export const WORKOUT_OBJECTIVES = {
    swimming: ["Técnica", "Adaptação", "Resistência", "Velocidade", "Triathlon", "Águas abertas"],
    strength: ["Hipertrofia", "Força", "Emagrecimento", "Adaptação", "Resistência", "Reabilitação"],
    running: ["Base", "5K", "10K", "Meia maratona", "Maratona", "Velocidade", "Retorno"],
    wod: ["Condicionamento", "Força", "Metabólico", "Skill", "Competitivo"],
};

export const WORKOUT_LEVELS = ["Iniciante", "Intermediário", "Avançado", "Master"];

export {
    SWIM_BLOCK_NAMES as BLOCK_NAMES,
    SWIM_EQUIPMENT_OPTIONS as SWIM_EQUIPMENT,
    SWIM_INTENSITY_ZONES as WORKOUT_INTENSITIES,
    SWIM_SET_TYPES,
    SWIM_STROKES as WORKOUT_STYLES,
} from "../domain/swimming/constants";
